import { render, staticRenderFns } from "./recruitDetail.vue?vue&type=template&id=024ac847&scoped=true"
import script from "./recruitDetail.vue?vue&type=script&lang=js"
export * from "./recruitDetail.vue?vue&type=script&lang=js"
import style0 from "./recruitDetail.vue?vue&type=style&index=0&id=024ac847&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "024ac847",
  null
  
)

export default component.exports